import { createContext } from 'react'

import { ISoAContext } from './types'

const SoAContext = createContext(null as unknown as ISoAContext)

export default SoAContext
